import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { adminMainUrl } from "../../../Config";
import Cookies from "js-cookie";
import "react-datepicker/dist/react-datepicker.css";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from 'axios';
import Accordion from 'react-bootstrap/Accordion';
import { toast } from 'react-toastify';
import QuotationAirImportModal from "./ImportModal/QuotationAirImportModal";
import { useDispatch, useSelector } from "react-redux";
import { getPricingQuoteDetail } from "../../../Redux/action/Sales/LeadStatusAction";
import Beatloader from "../../../Common/Loaders/Beatloader";
import { PricingRemarkModal } from "./PricingRemarkModal";
import AirQuotationModal from "./ImportModal/AirQuotationModal";
import { getQuoteCompGenInfo } from "../../../Redux/action/Sales/QuoteAirExportCompGenInfoAction";
import { getCurrency, getIncoterms, getViewRate } from "../../../Redux/action/MasterAction";
import OceanQuotationModal from "./ImportModal/OceanQuotationModal";
import { capitalizeFirstLetter, DDMMMYYYYformateDate } from "../../../HelperFunctions";
import { getAirline, getShipline } from "../../../Redux/action/Admin/EmployeeMasterAction";
// import { RemarkModal } from "../../Modal/RemarkModal";

const ViewPricingInformation = ({ process, showSideNavBar }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const { b64id } = useParams();
    let user_id = Cookies.get('flexichain_user_id');
    const [quotationId, setQuotationId] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [spinnerLoader, setSpinnerLoader] = useState(true);
    const [showPageLoader, setShowPageLoader] = useState(false);
    const [originType, setOriginType] = useState("");
    const [destinationType, setDestinationType] = useState("");
    const [additionalsArray, setAdditionalArray] = useState([]);
    const [remarkData, setRemarkData] = useState([]);
    const [modalExpImp, setModalExpImp] = useState("");
    const [shipmentMode, setShipmentMode] = useState("air");
    // for reamrk modal
    const [showRemark, setShowRemark] = useState(false);
    const handleCloseRemark = () => setShowRemark(false);
    const handleShowRemark = () => setShowRemark(true);

    //for quotation modal
    const [showAirQuotationModal, setShowAirQuotationModal] = useState(false);
    const handleCloseAirQuotationModal = () => setShowAirQuotationModal(false);
    const handleShowAirQuotationModal = () => setShowAirQuotationModal(true);

    const [showOceanQuotationModal, setShowOceanQuotationModal] = useState(false);
    const handleCloseOceanQuotationModal = () => setShowOceanQuotationModal(false);
    const handleShowOceanQuotationModal = () => setShowOceanQuotationModal(true);


    const openNewWindow = (url) => {
        const newWindow = window.open(
            url, // URL of the new window
            '_blank', // Target window name
            'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=1000,height=600' // Window features
        );
        const interval = setInterval(() => {
            if (newWindow.closed) {
                clearInterval(interval);
                refreshData();
            }
        }, 500);
    };

    const [isVisible, setIsVisible] = useState(false);
    const handleToggle = () => {
        setIsVisible(!isVisible);
    };

    const urlString = window.location.href;
    const url = new URL(urlString);
    const path = url.pathname.slice(1);
    const searchParams = url.search;
    const q = path + searchParams;
    const token = Cookies.get("token");

    useEffect(() => {
        if (!token) {
            toast.error("Please login to continue.");
            navigate(`/login?burl=${encodeURIComponent(q)}`);
        } else {
            if (b64id) {
                let id = atob(b64id);
                setQuotationId(id);
                if (user_id) {
                    dispatch(getPricingQuoteDetail(token, user_id, id));
                    dispatch(getViewRate(token, user_id, id));
                }
            } else {
                toast.error("Please enter correct url.")
                navigate(-1);
            }
        }
        dispatch(getAirline());
        dispatch(getShipline());
    }, [user_id]);

    const { loadingAirline,
        airlineDataError,
        airlineData,
        loadingShipline,
        shiplineDataError,
        shiplineData } = useSelector(state => state?.EmployeeMasterReducer);


    const [airlineOptions, setAirlineOptions] = useState([]);
    const [shiplineOptions, setShiplineOptions] = useState([]);


    useEffect(() => {
        if (airlineData) {
            let arr = [];
            airlineData.map(val => arr.push({ value: `${val?.name} - ${val?.international_code}`, label: `${val?.name} - ${val?.international_code}` }));
            setAirlineOptions(arr);
        }
    }, [loadingAirline, airlineData]);

    useEffect(() => {
        if (shiplineData) {
            let arr = [];
            shiplineData.map(val => arr.push({ value: `${val?.name}`, label: `${val?.name}` }));
            setShiplineOptions(arr);
        }
    }, [loadingShipline, shiplineData]);

    const refreshData = () => {
        if (user_id) {
            dispatch(getPricingQuoteDetail(token, user_id, quotationId));
            dispatch(getViewRate(token, user_id, quotationId));
        }
    };

    let { loadingViewRate, viewRateData, viewRateDataError } = useSelector(state => state?.MasterReducer);



    //get data from redux

    const { loadingPricingQuoteDetail, pricingQuoteDetailDataError, pricingQuoteDetailData } = useSelector(state => state?.LeadStatusReducer);

    useEffect(() => {
        // console.log(loadingPricingQuoteDetail);
        if (loadingPricingQuoteDetail) {
            setShowPageLoader(true);
        } else {
            setShowPageLoader(false);
        }
        if (pricingQuoteDetailData) {
            if (pricingQuoteDetailData?.additional_info) {
                setAdditionalArray(pricingQuoteDetailData?.additional_info)
            }

            if (pricingQuoteDetailData?.shipment_mode) {
                if (pricingQuoteDetailData?.shipment_mode == "air" || pricingQuoteDetailData?.shipment_mode == "ocean") { setShipmentMode(pricingQuoteDetailData?.shipment_mode) }
            }

            if (pricingQuoteDetailData?.quote_remarks) {
                setRemarkData(pricingQuoteDetailData?.quote_remarks)
            }

            if (pricingQuoteDetailData?.quotation_user_type) {
                if (pricingQuoteDetailData?.quotation_user_type === "IMPORTER") { setModalExpImp("Import") }
                if (pricingQuoteDetailData?.quotation_user_type === "EXPORTER") { setModalExpImp("Export") }
            }

            if (pricingQuoteDetailData?.shipment_mode == "courier") {
                setOriginType("");
                setDestinationType("")
            }
            if (pricingQuoteDetailData?.shipment_mode == "air") {
                setOriginType(`(${pricingQuoteDetailData?.origin_type})`);
                setDestinationType(`(${pricingQuoteDetailData?.destination_type})`);
            } else if (pricingQuoteDetailData?.shipment_mode == "ocean") {
                if (pricingQuoteDetailData?.origin_type == "AIRPORT") {
                    setOriginType(`(SEAPORT)`)
                } else {
                    setOriginType(`(${pricingQuoteDetailData?.origin_type})`);
                }

                if (pricingQuoteDetailData?.destination_type == "AIRPORT") {
                    setDestinationType(`(SEAPORT)`)
                } else {
                    setDestinationType(`(${pricingQuoteDetailData?.destination_type})`);
                }

            }
        }
    }, [loadingPricingQuoteDetail, pricingQuoteDetailDataError, pricingQuoteDetailData]);

    const showRelevantModal = () => {
        if (pricingQuoteDetailData) {
            if (pricingQuoteDetailData?.shipment_mode == "air") {
                setShowAirQuotationModal(true)
            } else if (pricingQuoteDetailData?.shipment_mode == "ocean") {
                setShowOceanQuotationModal(true)
            }
        }
    }

    function formatDate(dateString) {
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based, so we add 1
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    };


    const sendMessageToParent = () => {
        // Check if the opener window exists
        if (window.opener) {
            window.opener.postMessage('refreshPricingTableData', '*');
        }
    };

    const parsedFiles = JSON.parse(pricingQuoteDetailData?.files || "[]");
    const formik = useFormik({
        initialValues: {
            remarks: '', // Add an initial value for remarks
        },
        validationSchema: Yup.object({
            remarks: Yup.string().required("Please enter remark.")
        }),
        onSubmit: async (values, { setSubmitting, resetForm }) => {
            setIsSubmitting(true);

            try {
                const token = Cookies.get("token");
                const requestId = {
                    quotation_id: `${quotationId}`,
                    remarks: values.remarks, // Pass the remarks from the form
                };
                axios.post(`${adminMainUrl}/api/pricing/store-remarks`, requestId, {
                    headers: {
                        "Content-Type": "application/json",
                        "auth-token": token,
                        'user_id': user_id,
                    },
                })
                    .then((response) => {
                        if (response.status == 200) {
                            toast.success(response.data.msg);
                            resetForm(); // Reset form fields
                            dispatch(getPricingQuoteDetail(token, user_id, quotationId));
                            setIsSubmitting(false);
                        } else {
                            toast.error(response.data.msg);
                            setIsSubmitting(false);
                        }
                    })
                    .catch((error) => {
                        toast.error(error.response?.data?.msg || "An error occurred");
                        setIsSubmitting(false);
                    })
            } catch (error) {
                console.error(error);
                setIsSubmitting(false);
            }
        },
    });

    let [commodity_id, setCommodity_id] = useState(null);
    let [origin_port_id, setOriginPort_id] = useState(null);
    let [destination_port_id, setDestinationPort_id] = useState(null);
    let [attention_to, setAttention_to] = useState(null);
    let [total_wt, setTotal_wt] = useState(0);
    let [total_wt_unit, setTotal_wt_unit] = useState("Ton");
    useEffect(() => {
        if (pricingQuoteDetailData) {
            console.log(pricingQuoteDetailData);
            if (pricingQuoteDetailData.commodity_id) {
                setCommodity_id(pricingQuoteDetailData.commodity_id);
            }

            if (pricingQuoteDetailData.origin_port_int_id) {
                setOriginPort_id(pricingQuoteDetailData.origin_port_int_id)
            }
            if (pricingQuoteDetailData.destination_port_int_id) {
                setDestinationPort_id(pricingQuoteDetailData.destination_port_int_id)
            }

            if (pricingQuoteDetailData.picked_user) {
                setAttention_to(pricingQuoteDetailData.picked_user.name ?? "");
            }

            if (pricingQuoteDetailData.total_wt) {
                setTotal_wt(pricingQuoteDetailData.total_wt);
            }
            if (pricingQuoteDetailData.total_wt_unit) {
                setTotal_wt_unit(pricingQuoteDetailData.total_wt_unit);
            }
        }
    }, [pricingQuoteDetailData])

    return (
        <div className={showSideNavBar && "page-wrapper"}>
            {
                showPageLoader ?
                    <Beatloader />
                    :
                    <div className={showSideNavBar ? "content" : "content m-3"}>
                        <div className="row">
                            <div className="col-md-12">
                                {/* Page Header */}
                                <div className="page-header">
                                    <div className="row align-items-center">
                                        <div className="col-sm-4">
                                            <h4 className="page-title">
                                                View Information
                                            </h4>
                                        </div>
                                        <div className="col-sm-8 text-sm-end">

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-12">
                                {/* Contact User */}
                                <div className="contact-head">
                                    <div className="row align-items-center mb-3 ">
                                        <div className="col-sm-6">
                                            <ul className="contact-breadcrumb">
                                                <li className="mb-0">
                                                    {showSideNavBar && <Link to={-1}>
                                                        <i className="ti ti-arrow-narrow-left" />
                                                        View Information
                                                    </Link>}
                                                </li>

                                            </ul>
                                        </div>
                                        <div className="col-md-6">
                                            {/* Steps
                                                1.  if Price Received - View Rates
                                                2. If repricing  - view Rates + Give Rates
                                                3. else Give Rates
                                                4. if process = sent  => Only view rate
                                            */}
                                            <div className="d-flex justify-content-end align-items-center flex-wrap gap-3">
                                                {
                                                    process == "Sent" ?
                                                        <>
                                                            <div className="">
                                                                <div className="send_query_list_button send-query btn btn-danger" onClick={() => {
                                                                    // navigate(`/flexichain/pricing-export-view-rates/${btoa(quotationId)}`);
                                                                    // window.open(`/flexichain/pricing-export-view-rates-${shipmentMode}/${btoa(quotationId)}`);
                                                                    openNewWindow(`/flexichain/pricing-export-view-rates-${shipmentMode}/${btoa(quotationId)}`);
                                                                }}>
                                                                    View Rates
                                                                </div>
                                                            </div>
                                                        </>
                                                        :
                                                        (pricingQuoteDetailData?.quote_status?.name === "Price Received")
                                                            ?
                                                            <div className="">
                                                                <div className="send_query_list_button send-query btn btn-danger" onClick={() => {
                                                                    // navigate(`/flexichain/pricing-export-view-rates/${btoa(quotationId)}`);
                                                                    // window.open(`/flexichain/pricing-export-view-rates-${shipmentMode}/${btoa(quotationId)}`);
                                                                    openNewWindow(`/flexichain/pricing-export-view-rates-${shipmentMode}/${btoa(quotationId)}`);
                                                                }}>
                                                                    View Rates
                                                                </div>
                                                            </div>
                                                            :
                                                            (pricingQuoteDetailData?.quote_status?.name === "Repricing")
                                                                ?
                                                                <>
                                                                    <div className="">
                                                                        <div className="send_query_list_button send-query btn btn-danger" onClick={() => {
                                                                            // navigate(`/flexichain/pricing-export-view-rates/${btoa(quotationId)}`);
                                                                            // window.open(`/flexichain/pricing-export-view-rates-${shipmentMode}/${btoa(quotationId)}`);
                                                                            openNewWindow(`/flexichain/pricing-export-view-rates-${shipmentMode}/${btoa(quotationId)}`);
                                                                        }}>
                                                                            View Rates
                                                                        </div>
                                                                    </div>
                                                                    <div className="">
                                                                        <div className="send_query_list_button send-query btn btn-danger" onClick={() => {
                                                                            showRelevantModal()
                                                                        }}>
                                                                            Give Rates
                                                                        </div>
                                                                    </div>
                                                                </>
                                                                :
                                                                <div className="">
                                                                    <div className="send_query_list_button send-query btn btn-danger" onClick={() => {
                                                                        showRelevantModal()
                                                                    }}>
                                                                        Give Rates
                                                                    </div>
                                                                </div>
                                                }

                                                <div className="">
                                                    <div className="send_query_list_button send-query btn btn-danger" onClick={() => {
                                                        handleShowRemark()
                                                    }}>
                                                        View Remarks
                                                    </div>
                                                </div>

                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <div className="card mb-2">
                                    <div className="card-body pb-2">
                                        <div className="d-flex align-items-center justify-content-between flex-wrap">
                                            <div className="d-lg-flex align-items-start mb-2 w-100 justify-content-between">

                                                <div>
                                                    <div className="d-flex justify-content-start gap-2 py-1">
                                                        <p className="font-medium">Name </p>
                                                        <p className="mb-0 text-sm">{pricingQuoteDetailData?.full_name} ({pricingQuoteDetailData?.quotation_user_type})</p>
                                                    </div>
                                                    <div className="d-flex justify-content-start gap-2 py-1">
                                                        <p className="font-medium">Email </p>
                                                        <p className="mb-0 text-sm">{pricingQuoteDetailData?.email}</p>
                                                    </div>
                                                    <div className="d-flex justify-content-start gap-2 py-1">
                                                        <p className="font-medium">Mobile </p>
                                                        <p className="mb-0 text-sm">{pricingQuoteDetailData?.phone}</p>
                                                    </div>
                                                    <div className="d-flex justify-content-start gap-2 py-1">
                                                        <p className="font-medium">Created At </p>
                                                        <p className="mb-0 text-sm">{DDMMMYYYYformateDate(pricingQuoteDetailData?.createdAt)}</p>
                                                    </div>

                                                </div>

                                                <div>
                                                    <div className="d-flex justify-content-start gap-2 py-1">
                                                        <p className="font-medium">Request No </p>
                                                        <p className="mb-0 text-sm">{pricingQuoteDetailData?.request_no}</p>
                                                    </div>
                                                    <div className="d-flex justify-content-start gap-2 py-1">
                                                        <p className="font-medium">Status </p>
                                                        <p className="mb-0 text-sm">{pricingQuoteDetailData?.quote_status?.name}</p>
                                                    </div>
                                                    <div className="d-flex justify-content-start gap-2 py-1">
                                                        <p className="font-medium">Picked by </p>
                                                        <p className="mb-0 text-sm">{pricingQuoteDetailData?.pricing_user ? `${pricingQuoteDetailData?.pricing_user?.name}` : "-"}</p>
                                                    </div>
                                                    <div className="d-flex justify-content-start gap-2 py-1">
                                                        <p className="font-medium">Sales Person </p>
                                                        <p className="mb-0 text-sm">{pricingQuoteDetailData?.picked_user ? `${pricingQuoteDetailData?.picked_user?.name}` : "-"}</p>
                                                    </div>


                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                {/* /Contact User */}
                            </div>
                            {/* Contact Sidebar */}

                            {/* /Contact Sidebar */}
                            {/* Contact Details */}
                            <div className="col-xl-12">
                                <div className="card mb-2">
                                    <div className="card-body pb-0 pt-2">
                                        <ul className="nav nav-tabs nav-tabs-bottom" role="tablist">
                                            <li className="nav-item" role="presentation">
                                                <a
                                                    href="#"
                                                    data-bs-toggle="tab"
                                                    data-bs-target="#activities"
                                                    className="nav-link active"
                                                >
                                                    <i className="ti ti-alarm-minus me-1" />
                                                    Pickup Information
                                                </a>
                                            </li>


                                        </ul>
                                    </div>
                                </div>
                                {/* Tab Content */}
                                <div className="tab-content pt-0">
                                    {/* Activities */}
                                    <div className="tab-pane active show" id="activities">
                                        <div className="card">

                                            <div className="card-body">
                                                <div className="pb-4 px-md-0 px-3 view-info-box">

                                                    <div className="row">
                                                        <div className=" col-md-6 py-2">

                                                            <div className="d-flex justify-content-start gap-2 py-2">
                                                                <p className="font-medium">Origin </p>
                                                                {/* <div className="box-query"> */}
                                                                <p className="mb-0 text-sm">
                                                                    {pricingQuoteDetailData?.origin_type == "AIRPORT" ?
                                                                        `${pricingQuoteDetailData?.origin_port_full_name} ${originType}` :
                                                                        `${pricingQuoteDetailData?.origin_address}, ${pricingQuoteDetailData?.origin_city ? pricingQuoteDetailData?.origin_city?.name : ""}, ${pricingQuoteDetailData?.origin_state ? pricingQuoteDetailData?.origin_state?.name : ""}, ${pricingQuoteDetailData?.origin_country ? pricingQuoteDetailData?.origin_country?.name : ""} ${originType}`}
                                                                </p>
                                                                {/* </div> */}
                                                            </div>
                                                            <div className="d-flex justify-content-start gap-2 py-2">
                                                                <p className="font-medium">Destination</p>
                                                                {/* <div className="box-query"> */}

                                                                <p className="mb-0 text-sm">{pricingQuoteDetailData?.destination_type == "AIRPORT" ? `${pricingQuoteDetailData?.destination_port_full_name} (${pricingQuoteDetailData?.origin_type})` : `${pricingQuoteDetailData?.destination_address}, ${pricingQuoteDetailData?.destination_city ? pricingQuoteDetailData?.destination_city?.name : ""}, ${pricingQuoteDetailData?.destination_state ? pricingQuoteDetailData?.destination_state?.name : ""}, ${pricingQuoteDetailData?.destination_country ? pricingQuoteDetailData?.destination_country?.name : ""} ${pricingQuoteDetailData?.origin_type}`}</p>
                                                                {/* </div> */}
                                                            </div>
                                                            {pricingQuoteDetailData?.shipment_mode !== "courier" && <div className="d-flex justify-content-start gap-2 py-2">
                                                                <p className="font-medium">Incoterm</p>

                                                                <p className="mb-0 text-sm">{pricingQuoteDetailData?.incoterm ? pricingQuoteDetailData?.incoterm?.name : <i>N/A</i>}</p>

                                                            </div>}

                                                            <div className="d-flex justify-content-start gap-2 py-2">
                                                                <p className="font-medium">Commodity</p>

                                                                <p className="mb-0 text-sm">{pricingQuoteDetailData?.commodity ? pricingQuoteDetailData?.commodity.name : <i>N/A</i>}</p>

                                                            </div>


                                                        </div>
                                                        <div className=" col-md-6 py-2">
                                                            <div className="d-flex justify-content-start gap-2 py-2">
                                                                <p className="font-medium">Shipment Mode </p>
                                                                {/* <div className="box-query"> */}
                                                                <p className="mb-0 text-sm">{pricingQuoteDetailData?.shipment_mode ? capitalizeFirstLetter(pricingQuoteDetailData?.shipment_mode) : ""}</p>
                                                                {/* </div> */}
                                                            </div>


                                                            <div className="d-flex justify-content-start gap-2 py-2">
                                                                <p className="font-medium">Cargo Ready Date </p>
                                                                {/* <div className="box-query"> */}

                                                                <p className="mb-0 text-sm">{DDMMMYYYYformateDate(pricingQuoteDetailData?.cargo_ready_date)}</p>
                                                                {/* </div> */}
                                                            </div>

                                                            {pricingQuoteDetailData && pricingQuoteDetailData?.shipment_mode !== "air" && pricingQuoteDetailData?.shipment_mode !== "courier" ? <div className="d-flex justify-content-start gap-2 py-2">
                                                                <p className="font-medium">Load Type </p>
                                                                {/* <div className="box-query"> */}

                                                                <p className="mb-0 text-sm">{pricingQuoteDetailData?.load_type}</p>
                                                                {/* </div> */}
                                                            </div> : ""}
                                                            <div className="d-flex justify-content-start gap-2 py-2">
                                                                <p className="font-medium">Service Type</p>

                                                                <p className="mb-0 text-sm">{pricingQuoteDetailData?.service_type ? pricingQuoteDetailData?.service_type : <i>N/A</i>}</p>

                                                            </div>

                                                            <div className="d-flex justify-content-start gap-2 py-2">
                                                                <p className="font-medium">Pickup Address</p>

                                                                <p className="mb-0 text-sm">{pricingQuoteDetailData?.service_type ? pricingQuoteDetailData?.pickup_address : <i>N/A</i>}</p>

                                                            </div>

                                                              <div className="d-flex justify-content-start gap-2 py-2">
                                                                <p className="font-medium">Drop Address</p>

                                                                <p className="mb-0 text-sm">{pricingQuoteDetailData?.service_type ? pricingQuoteDetailData?.drop_address : <i>N/A</i>}</p>

                                                            </div>
                                                        </div>
                                                        <div className="col-12 py-2">
                                                            <div className=" py-2">
                                                                <div className=" d-sm-flex mb-2 align-items-center">
                                                                    <p className="font-medium ">Additionals
                                                                    </p>
                                                                    {/* {accessedPermission.includes("add_master_data") && <p data-bs-toggle="modal" data-bs-target="#add-aditionals" className="text-start " style={{ marginRight: '10px', cursor: 'pointer', color: "#E41F07" }}>
                                                                        + Add Aditional
                                                                    </p>} */}
                                                                </div>

                                                                <div className="row">
                                                                    {additionalsArray.map((val, _i) => {
                                                                        return (
                                                                            <div className="col-md-3" key={_i + 1}>
                                                                                <div className="form-check form-switch">
                                                                                    <input
                                                                                        className="form-check-input form-switch-add"
                                                                                        type="checkbox"
                                                                                        role="switch"
                                                                                        id={`flexSwitchCheckDefault${_i}`}
                                                                                        value={val?.value}
                                                                                        checked={val.included}
                                                                                        disabled
                                                                                        style={{ opacity: 1 }}
                                                                                    />
                                                                                    <label
                                                                                        className="form-check-label"
                                                                                        htmlFor={`flexSwitchCheckDefault${_i}`}
                                                                                    >
                                                                                        {val.name}
                                                                                    </label>
                                                                                </div>
                                                                            </div>
                                                                        );
                                                                    })}


                                                                </div>

                                                            </div>

                                                        </div>
  <div className="col-12 py-2">
                                                            <div className=" py-2">
                                                                <div className=" d-sm-flex mb-2 align-items-center">
                                                                    <p className="font-medium ">Specail Handling
                                                                    </p>

                                                                </div>

                                                                <div className="row">
                                                               <p className="mb-0 text-sm"> {pricingQuoteDetailData?.special_handling ? pricingQuoteDetailData?.special_handling : "No" } </p>
                                                                </div>
                                                            </div>

                                                        </div>


                                                        {
                                                            pricingQuoteDetailData?.shipment_mode !== 'air' && pricingQuoteDetailData?.load_type == "FULL" ?
                                                                <div className="col-12 py-2 ">
                                                                    <p className="font-medium mb-3">Cargo Details</p>
                                                                    <div className="table-responsive">


                                                                        <table className="posts-table mb-0  table table-bordered view-info-table">
                                                                            <thead>
                                                                                <tr>
                                                                                    <th scope="col"> Quantity</th>
                                                                                    <th scope="col">Container Size</th>
                                                                                    <th scope="col">Container Type</th>
                                                                                    <th scope="col">Unit Weight</th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                <tr>
                                                                                    <td>{pricingQuoteDetailData?.fl_quantity ?? "N/A"}</td>
                                                                                    <td> {pricingQuoteDetailData?.containersize ? pricingQuoteDetailData?.containersize?.name : "N/A"}</td>
                                                                                    <td> {pricingQuoteDetailData?.containertype ? pricingQuoteDetailData?.containertype?.name : "N/A"}</td>
                                                                                    <td> {pricingQuoteDetailData?.fl_weight} {pricingQuoteDetailData?.fl_weight_unit_id ?? "N/A"}</td>
                                                                                </tr>
                                                                            </tbody>
                                                                        </table>

                                                                    </div>
                                                                </div>
                                                                :
                                                                <div className="col-12 py-2 ">
                                                                    <p className="font-medium mb-3">Package Dimensions/Weight</p>
                                                                    <div className="table-responsive">
                                                                        <table className="posts-table mb-0  view-info-table">
                                                                            <tbody>
                                                                                <tr>
                                                                                    <td className="p-0">
                                                                                        <tr>
                                                                                            {pricingQuoteDetailData?.package_volume_type === "VOLUME" ?

                                                                                                <td style={{ border: "1px solid #c7c7c7" }}>
                                                                                                    Volume
                                                                                                </td>
                                                                                                : <><td style={{ border: "1px solid #c7c7c7" }}>
                                                                                                    Length
                                                                                                </td>
                                                                                                    <td style={{ border: "1px solid #c7c7c7" }}>
                                                                                                        Width
                                                                                                    </td>
                                                                                                    <td style={{ border: "1px solid #c7c7c7" }}>
                                                                                                        Height
                                                                                                    </td></>}
                                                                                            <td style={{ border: "1px solid #c7c7c7" }}>
                                                                                                Package Type
                                                                                            </td>
                                                                                            <td style={{ border: "1px solid #c7c7c7" }}>
                                                                                               Volumetric Weight
                                                                                            </td>
                                                                                            {/* <td style={{ border: "1px solid #c7c7c7" }}>
                                                                                                Unit
                                                                                            </td> */}
                                                                                            <td style={{ border: "1px solid #c7c7c7" }}>
                                                                                                Gross Weight
                                                                                            </td>
                                                                                            {/* <td style={{ border: "1px solid #c7c7c7" }}>
                                                                                                Gross Weight Unit
                                                                                            </td> */}
                                                                                            <td style={{ border: "1px solid #c7c7c7" }}>
                                                                                                Total Box
                                                                                            </td>
                                                                                        </tr>
                                                                                        {
                                                                                            pricingQuoteDetailData?.package_info ? (
                                                                                                (pricingQuoteDetailData?.package_info).map((value, index) => {
                                                                                                    return (
                                                                                                        <tr key={index}>
                                                                                                            {
                                                                                                                pricingQuoteDetailData?.package_volume_type === "VOLUME" ?

                                                                                                                    <td style={{ border: "1px solid #c7c7c7" }}>
                                                                                                                        {value?.volume ? `${value?.volume} ${value?.volumeunit}` : 'N/A'}
                                                                                                                    </td> :

                                                                                                                    <>
                                                                                                                        <td style={{ border: "1px solid #c7c7c7" }}>
                                                                                                                            {value?.length ? `${value?.length} ${value?.dimensionunit}` : 'N/A'}
                                                                                                                        </td>
                                                                                                                        <td style={{ border: "1px solid #c7c7c7" }}>
                                                                                                                            {value?.width ? `${value?.width} ${value?.dimensionunit}` : 'N/A'}
                                                                                                                        </td>
                                                                                                                        <td style={{ border: "1px solid #c7c7c7" }}>
                                                                                                                            {value?.height ? `${value?.height} ${value?.dimensionunit}` : 'N/A'}
                                                                                                                        </td>
                                                                                                                    </>
                                                                                                            }

                                                                                                            <td style={{ border: "1px solid #c7c7c7" }}>
                                                                                                                {value?.package_type ? value?.package_type?.name : 'N/A'}
                                                                                                            </td>
                                                                                                            <td style={{ border: "1px solid #c7c7c7" }}>
                                                                                                                {value?.max_weight ? `${value?.max_weight} ${value?.max_weight_unit}` : 'N/A'}
                                                                                                            </td>

                                                                                                            <td style={{ border: "1px solid #c7c7c7" }}>
                                                                                                                {value?.gross_weight ? `${value?.gross_weight} ${value?.gross_weight_unit}` : 'N/A'}
                                                                                                            </td>

                                                                                                            <td style={{ border: "1px solid #c7c7c7" }}>
                                                                                                                {value?.total_boxes || 'N/A'}
                                                                                                            </td>
                                                                                                        </tr>
                                                                                                    );
                                                                                                })
                                                                                            ) : (
                                                                                                <tr>
                                                                                                    <td colSpan="9" style={{ border: "1px solid #c7c7c7", textAlign: "center" }}>
                                                                                                        No data available
                                                                                                    </td>
                                                                                                </tr>
                                                                                            )
                                                                                        }
                                                                                    </td>
                                                                                </tr>

                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                </div>
                                                        }

                                                    </div>

                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <table className="posts-table w-100">
                                                                <tbody>
                                                                    <tr>
                                                                        <td className="send_query_list_button w-fit p-0 send-query" style={{ background: "none", color: "#000" }}>
                                                                            <div className="remark-section" >
                                                                                <p id="remarks" onClick={handleToggle} className="text-start" style={{ marginRight: '10px', cursor: 'pointer', color: "rgb(100, 112, 197)" }}>
                                                                                    <b>+ Add Remark</b>
                                                                                </p>
                                                                                <form onSubmit={formik.handleSubmit}>
                                                                                    <div id="remarks" style={{ display: isVisible ? "block" : "none" }}>
                                                                                        <textarea
                                                                                            id="remarks-input"
                                                                                            name="remarks"
                                                                                            className="form-control mb-2"
                                                                                            value={formik.values.remarks}
                                                                                            onChange={formik.handleChange}
                                                                                            onBlur={formik.handleBlur}
                                                                                            placeholder="Write Something Here...."
                                                                                            style={{ marginRight: '10px' }}
                                                                                        ></textarea>
                                                                                        {formik.touched.remarks && formik.errors.remarks ? (
                                                                                            <div className="error" style={{ color: 'red' }}>{formik.errors.remarks}</div>
                                                                                        ) : null}
                                                                                        <div className="text-end">
                                                                                            <button className="send_query_list_button send-query desc-btn py-1 btn btn-danger" disabled={isSubmitting}>
                                                                                                {isSubmitting ? <div><i className="fa fa-spinner fa-spin" /> Add</div> : "Add"}
                                                                                            </button>
                                                                                        </div>
                                                                                    </div>
                                                                                </form>
                                                                            </div>
                                                                        </td>
                                                                    </tr>

                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
            }

            <AirQuotationModal quotationId={quotationId} show={showAirQuotationModal} handleClose={handleCloseAirQuotationModal} modalExpImp={modalExpImp} pricingQuoteDetailData={pricingQuoteDetailData} refreshData={refreshData} loadingViewRate={loadingViewRate} viewRateData={viewRateData} sendMessageToParent={sendMessageToParent} loadingAirline={loadingAirline} airlineOptions={airlineOptions} commodity_id={commodity_id} origin_port_id={origin_port_id} destination_port_id={destination_port_id} attention_to={attention_to} total_wt={total_wt} total_wt_unit={total_wt_unit} />

            <OceanQuotationModal quotationId={quotationId} show={showOceanQuotationModal} handleClose={handleCloseOceanQuotationModal} modalExpImp={modalExpImp} pricingQuoteDetailData={pricingQuoteDetailData} refreshData={refreshData} loadingViewRate={loadingViewRate} viewRateData={viewRateData} sendMessageToParent={sendMessageToParent} loadingShipline={loadingShipline} shiplineOptions={shiplineOptions} commodity_id={commodity_id} origin_port_id={origin_port_id} destination_port_id={destination_port_id} attention_to={attention_to} total_wt={total_wt} total_wt_unit={total_wt_unit} />

            <PricingRemarkModal remarkData={remarkData} show={showRemark} handleClose={handleCloseRemark} />
        </div>

    )
}

export default ViewPricingInformation